export default __webpack_public_path__ + "static/media/show-pruner-1.f2a611ba.webp";